import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { InformationsRowBlockConfig } from '@front-platform/content-builder';
import { informationsRowBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface InformationsRowBlockRuntimeConfig {}

export type InformationsRowBlockConfigInput = Partial<
  Omit<InformationsRowBlockConfig, keyof InformationsRowBlockRuntimeConfig> &
    InformationsRowBlockRuntimeConfig
>;
export type InformationsRowBlockResolvedConfig = Omit<
  InformationsRowBlockConfig,
  keyof InformationsRowBlockRuntimeConfig
> &
  Partial<InformationsRowBlockRuntimeConfig>;
export interface InformationsRowBlockContract extends ConfigComponentContract<
  InformationsRowBlockConfigInput,
  InformationsRowBlockResolvedConfig
> {}

@Component({
  selector: 'app-informations-row-block',
  templateUrl: './informations-row-block.component.html',
  standalone: false,
})
export class InformationsRowBlockComponent implements InformationsRowBlockContract {
  readonly config = input<InformationsRowBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    InformationsRowBlockConfig,
    InformationsRowBlockRuntimeConfig
  >(informationsRowBlockResolveConfig, () => ({ config: this.config() }));
  get content(): string {
    return this.resolvedConfig()['content'] as unknown as string;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(InformationsRowBlockComponent, { 'keyAliases': {} });
